import { apiInstance } from "../utils/_apiInstance";

interface GetSavedDocumentParams {
  type?: string;
  page?: number;
  limit?: number;
}

interface SavedDocumentItem {
  _id: string;
  tipo?: string;
  salvoEm?: string;
  documento?: any;
}

interface SavedDocumentResponse {
  page: number;
  limit: number;
  total: number;
  itens: SavedDocumentItem[];
}

export const getSavedDocument = async ({
  type = "",
  page = 1,
  limit = 10,
}: GetSavedDocumentParams = {}) => {
  const response = await apiInstance.get<SavedDocumentResponse>("/documentos", {
    params: {
      tipo: type,
      page,
      limit,
    },
  });
  return response.data;
};
